import { createContext, useState } from "react"

export const scenes = createContext();

export default function Scene({children}) {
    const [sceneEmp, setSceneEmp] = useState({});
    const [dataInv, setDataEnv] = useState([]);

    const parent = {
        sceneEmp, 
        setSceneEmp,
        setDataEnv,
        dataInv
    }

    return <scenes.Provider value={parent}>{children}</scenes.Provider>
}